<div class="modal-header" data-cy="workflowTaskModalModalHeader">
	<h2 class="modal-title">
		{{ taskGroup()?.id ? "Edit" : "Add" }} Task Rule on: <strong>{{ task().taskName }}</strong>
	</h2>
	<button type="button" class="btn btn-close" aria-label="Close" (click)="close()" data-cy="closeModal">
		<i class="fal fa-xmark"></i>
	</button>
</div>
<div class="modal-body" data-cy="workflowTaskModalModalBody">
	<rl-workflow-task-group-form #rulesForm [charTypeId]="charTypeId()" [processId]="processId()" [task]="task()"
		[taskGroup]="taskGroup()">
	</rl-workflow-task-group-form>
</div>
<div class="modal-footer">
	<button type="button" class="btn btn-light" (click)="close()" data-cy="workflowTaskModalCancel">
		Cancel
	</button>
	<button type="button" class="btn btn-success" (click)="save(rulesForm.buildTaskControlGroup())"
		[disabled]="!rulesForm.isDirty || !rulesForm.isValid" data-cy="workflowTaskModalClose" rlBusyButton>
		Save
	</button>
</div>